module.exports = [{
      plugin: require('/Users/david/Sites/dc-info-gatsby/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Cabin","Libre Franklin","Open Sans"]}},
    },{
      plugin: require('/Users/david/Sites/dc-info-gatsby/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-145242971-1","head":true},
    },{
      plugin: require('/Users/david/Sites/dc-info-gatsby/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/assets/images/website-icon.png"},
    },{
      plugin: require('/Users/david/Sites/dc-info-gatsby/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/david/Sites/dc-info-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
